export default{label:"w_AE",checked:"w_AF",indeterminate:"w_AG",disabled:"w_AH",input:"w_AI",checkbox:"w_AJ",labelText:"w_AK"};
